<template>
  <div>
    <h5>Globalt</h5>
    <table v-if="!selectedTrigger">
      <tbody>
        <tr @click="clientId = -1; triggerValue = true"><td>Någon kommer hem</td></tr>
        <tr @click="clientId = -1; triggerValue = false"><td>Ingen är närvarande</td></tr>
      </tbody>
    </table>

    <div v-for="client in $root.data.clients.filter(x => x.presenceEnable)">
      <h5>{{ client.deviceName }}</h5>

      <table>
        <tbody>
          <tr @click="clientId = client.id; triggerValue = true"><td>Kommer hem</td></tr>
          <tr @click="clientId = client.id; triggerValue = false"><td>Lämnar</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'trigger_presence',
    props: ['type'],
    data () {
      return {
        selectedTrigger: null,
        triggerValue: null,
        sendTriggerTimer: null,
        clientId: 0
      }
    },
    created() {
      this.sendTriggerTimer = setInterval(() => this.$emit('test', this.formattedTrigger), 100)
    },
    
    destroyed () {
      clearInterval(this.sendTriggerTimer)
    },
    methods: {
      didChange () {
      }
    },
    computed: {
      formattedTrigger () {
        if (!this.clientId)
          return {}
          
        const obj = {
          systemType: 'presence',
          subtype: 'none',
          operator: 'eq',
          clientId: this.clientId,
          value: this.triggerValue
        }
          
        return obj
      },

      triggers () {
        return []
      },

      triggerType () {
        if (this.selectedTrigger)
          return this.selectedTrigger.type
        return ''
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/automationer/trigger_presence.vue